import { ApiProperty } from '../../decorators/decorators';
import { Precision } from '../sensor';
import { ExtendedMatColorTheme } from './tenant-configuration.model';
import { UUID } from '@ird/shared-base';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class TenantSettings {
  tenantId: string;
  tenantName: string;
  brandName: string;
  tenantCompanyName: string;
  tenantAddress: string;
  tenantEmail: string;
  hosts: string[];
  themeDefinition: ExtendedMatColorTheme;
  logoFileId: string;
  emailFileId: string;
  outboundNotificationEnabled = true;
  defaultDeviceImageFileId: string;
  emailLogoFileId: string;
  contactPersonList?: Array<unknown>;
  @ApiProperty({
    type: 'array',
    items: { type: 'object', additionalProperties: true },
  })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  features: any[];
  timeoutDuration?: number;
  precisions?: Precision[];
  defaultBrandId?: UUID;
  defaultManufacturerId?: UUID;
  defaultProductionSiteId?: UUID;
  defaultBusiness?: string;
  defaultRegion?: string;
}

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export interface TenantConfigurationDto {
  contactPersonList?: Array<unknown>;
  defaultDeviceImageFileId: string;
  defaultModelId: string;
  emailLogoFileId?: string;
  features: any[];
  logoFileId: string;
  outboundNotificationEnabled: boolean;
  tenantId: string;
  themeDefinition: ExtendedMatColorTheme;
  timeoutDuration: number;
}

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */

export interface ServicePointTenantConfigurationDto extends TenantConfigurationDto {
  businessUnitName: string;
}
